import { SubCard } from "./Card.tsx";

const CardActions = ({
  title,
  description,
  onClick,
  buttonText,
}: {
  title: string;
  description: string;
  onClick: () => void;
  buttonText: string;
}) => {
  return (
    <SubCard title={title}>
      <p>{description}</p>
      <div className="card-actions justify-end">
        <button onClick={() => onClick()} className="btn">
          {buttonText}
        </button>
      </div>
    </SubCard>
  );
};

export default CardActions;
